import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.nodes');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';
import { TranslateService } from '@ngx-translate/core';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-nodes',
template: templateSource || '',
    styles: [``],
})
export class PageKieraNodesComponent implements OnInit, OnDestroy {

    public readonly statusOptions: Array<{ value: string; label: string; }> = [
        { value: 'new', label: 'NEW' },
        { value: 'commissioning', label: 'COMMISSIONING' },
        { value: 'ready', label: 'READY' },
        { value: 'deploying', label: 'DEPLOYING' },
        { value: 'deployed', label: 'DEPLOYED' },
        { value: 'failed', label: 'FAILED' },
    ];
    public readonly pageWindowSize: number = 10;
    public readonly pageSizeOptions: number[] = [10, 20, 50, 100];
    public readonly exportCsvFields: Array<{ key: string; header: string; }> = [
        { key: 'name', header: 'name' },
        { key: 'bmc_ip', header: 'bmc_ip' },
        { key: 'bmc_mac', header: 'bmc_mac' },
        { key: 'bmc_credential_name', header: 'bmc_credential_name' },
        { key: 'mac_address', header: 'mac_address' },
        { key: 'ip_address', header: 'ip_address' },
        { key: 'group_name', header: 'group_name' },
        { key: 'rack', header: 'rack' },
        { key: 'unit', header: 'unit' },
        { key: 'rack_size', header: 'rack_size' },
        { key: 'boot_type', header: 'boot_type' },
        { key: 'ethernet1_name', header: 'ethernet1_name' },
        { key: 'ethernet1_ip', header: 'ethernet1_ip' },
        { key: 'ethernet1_mac', header: 'ethernet1_mac' },
        { key: 'ethernet2_name', header: 'ethernet2_name' },
        { key: 'ethernet2_ip', header: 'ethernet2_ip' },
        { key: 'ethernet2_mac', header: 'ethernet2_mac' },
        { key: 'ethernet3_name', header: 'ethernet3_name' },
        { key: 'ethernet3_ip', header: 'ethernet3_ip' },
        { key: 'ethernet3_mac', header: 'ethernet3_mac' },
        { key: 'ethernet4_name', header: 'ethernet4_name' },
        { key: 'ethernet4_ip', header: 'ethernet4_ip' },
        { key: 'ethernet4_mac', header: 'ethernet4_mac' },
        { key: 'ib1_name', header: 'ib1_name' },
        { key: 'ib1_ip', header: 'ib1_ip' },
        { key: 'ib1_mac', header: 'ib1_mac' },
        { key: 'ib2_name', header: 'ib2_name' },
        { key: 'ib2_ip', header: 'ib2_ip' },
        { key: 'ib2_mac', header: 'ib2_mac' },
    ];

    public list: any[] = [];
    public groups: any[] = [];
    public bmcCredentialProfiles: any[] = [];
    public total: number = 0;
    public search: any = { text: "", page: 1, dump: 10, group_id: "", status: "", bmc_type: "" };
    public bmcTypes: string[] = ['IPMI', 'REDFISH', 'MQTT'];
    public showAddModal: boolean = false;
    public newNode: any = { name: '', group_id: '', rack: '', mac_address: '', bmc_ip: '', bmc_mac: '', bmc_credential_id: '' };
    public importingCsv: boolean = false;
    public exportingCsv: boolean = false;
    public csvImportResult: any = null;
    public selectionMode: boolean = false;
    public selectedNodeIds: Set<number> = new Set();
    public bulkDeleting: boolean = false;
    public deletingNodeIds: Set<number> = new Set();
    public showDuplicateImportModal: boolean = false;
    public pendingCsvImportData: string = '';
    public csvImportPreviewTotal: number = 0;
    public duplicateImportRows: any[] = [];
    public duplicateImportActions: any = {};
    public duplicateImportActionOptions: Array<{ value: string; labelKey: string; }> = [
        { value: 'skip', labelKey: 'page.nodes.duplicate_action_skip' },
        { value: 'overwrite', labelKey: 'page.nodes.duplicate_action_overwrite' },
    ];

    // Sorting
    public sortField: string = 'name';
    public sortDir: string = 'asc';

    constructor(@Inject( Service) public service: Service,@Inject( TranslateService)  private translate: TranslateService) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load(1, false, true);
        await this.service.render();
    }

    ngOnDestroy() {
    }

    public async loadGroups(render: boolean = true) {
        const { code, data } = await wiz.call("groups");
        if (code === 200) this.groups = data;
        if (render) await this.service.render();
    }

    public async loadBmcCredentials(render: boolean = true) {
        const { code, data } = await wiz.call('bmc_credentials');
        if (code === 200) this.bmcCredentialProfiles = data?.rows || [];
        if (render) await this.service.render();
    }

    public async load(page: number = 1, render: boolean = true, includeMeta: boolean = false) {
        this.search.page = page;
        const { code, data } = await wiz.call("search", {
            ...this.search,
            include_meta: includeMeta ? 1 : 0,
        });
        if (code === 200) {
            this.list = data.rows;
            this.total = data.total;
            if (includeMeta) {
                this.groups = Array.isArray(data?.groups) ? data.groups : [];
                this.bmcCredentialProfiles = Array.isArray(data?.bmc_credentials)
                    ? data.bmc_credentials
                    : [];
            }
            this.sortList();
        }
        if (render) await this.service.render();
    }

    public async deleteNode(id: number) {
        const nodeId = Number(id);
        if (!Number.isFinite(nodeId) || nodeId <= 0 || this.isDeletingNode(nodeId)) return;
        if (!confirm(this.translate.instant('page.nodes.confirm_delete'))) return;

        this.deletingNodeIds.add(nodeId);
        await this.service.render();
        try {
            const { code, data } = await wiz.call("delete", { id: nodeId });
            if (code === 200) {
                await this.load(this.search.page);
            } else {
                alert(data?.message || this.translate.instant('page.nodes.delete_failed'));
            }
        } catch (error) {
            console.error(error);
            alert(this.translate.instant('page.nodes.delete_failed'));
        } finally {
            this.deletingNodeIds.delete(nodeId);
            await this.service.render();
        }
    }

    public async toggleSelectionMode() {
        this.selectionMode = !this.selectionMode;
        if (!this.selectionMode) this.selectedNodeIds.clear();
        await this.service.render();
    }

    public handleRowClick(item: any) {
        if (this.selectionMode) {
            this.toggleNodeSelection(item?.id);
            return;
        }
        this.viewNode(item.id);
    }

    public isNodeSelected(id: any): boolean {
        return this.selectedNodeIds.has(Number(id));
    }

    public isDeletingNode(id: any): boolean {
        return this.deletingNodeIds.has(Number(id));
    }

    public toggleNodeSelection(id: any) {
        const nodeId = Number(id);
        if (!Number.isFinite(nodeId) || nodeId <= 0) return;
        if (this.selectedNodeIds.has(nodeId)) this.selectedNodeIds.delete(nodeId);
        else this.selectedNodeIds.add(nodeId);
    }

    public togglePageSelection(event: any) {
        const checked = !!event?.target?.checked;
        this.list.forEach((item: any) => {
            const nodeId = Number(item?.id);
            if (!Number.isFinite(nodeId) || nodeId <= 0) return;
            if (checked) this.selectedNodeIds.add(nodeId);
            else this.selectedNodeIds.delete(nodeId);
        });
    }

    public allPageNodesSelected(): boolean {
        return this.list.length > 0 && this.list.every((item: any) => this.selectedNodeIds.has(Number(item?.id)));
    }

    public async bulkDeleteSelected() {
        const ids = Array.from(this.selectedNodeIds);
        if (ids.length === 0 || this.bulkDeleting) return;
        if (!confirm(this.translate.instant('page.nodes.confirm_bulk_delete', { count: ids.length }))) return;

        this.bulkDeleting = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call("bulk_delete", { ids: JSON.stringify(ids) });
            if (code === 200) {
                const deleted = Number(data?.deleted || ids.length);
                const nextTotal = Math.max(0, this.total - deleted);
                const nextPage = Math.min(this.search.page, Math.ceil(nextTotal / this.search.dump) || 1);
                this.selectedNodeIds.clear();
                this.selectionMode = false;
                await this.load(nextPage);
                if (data?.errors?.length) alert(this.translate.instant('page.nodes.bulk_delete_failed'));
            } else {
                alert(data?.message || this.translate.instant('page.nodes.bulk_delete_failed'));
            }
        } finally {
            this.bulkDeleting = false;
            await this.service.render();
        }
    }

    public async addNode() {
        if (!this.newNode.name.trim()) return;
        const { code } = await wiz.call("create", { data: JSON.stringify(this.newNode) });
        if (code === 200) {
            this.showAddModal = false;
            this.newNode = { name: '', group_id: '', rack: '', mac_address: '', bmc_ip: '', bmc_mac: '', bmc_credential_id: '' };
            await this.load();
        }
    }

    public triggerCsvImport() {
        if (this.importingCsv) return;
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.csv,text/csv';
        input.onchange = async (event: any) => {
            const file = event?.target?.files?.[0];
            if (!file) return;
            await this.importCsvFile(file);
        };
        input.click();
    }

    private readFileAsText(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = (event: any) => resolve(String(event?.target?.result || ''));
            reader.onerror = () => reject(reader.error || new Error('Failed to read file'));
            reader.readAsText(file, 'utf-8');
        });
    }

    private bmcCredentialName(row: any): string {
        return String(row?.bmc_credential_name || '').trim();
    }

    public async importCsvFile(file: File) {
        this.importingCsv = true;
        this.csvImportResult = null;
        await this.service.render();
        try {
            const fileData = await this.readFileAsText(file);
            const preview = await wiz.call("import_csv", {
                file_data: fileData,
                preview: 1,
            });
            if (preview.code !== 200) {
                alert(preview.data?.message || this.translate.instant('page.nodes.import_failed'));
                return;
            }

            const conflicts = Array.isArray(preview.data?.conflicts)
                ? preview.data.conflicts
                : (Array.isArray(preview.data?.duplicates) ? preview.data.duplicates : []);
            if (conflicts.length > 0) {
                this.openCsvImportConflictReview(fileData, preview.data, conflicts);
                return;
            }

            await this.executeCsvImport(fileData, {});
        } catch (error) {
            console.error(error);
            alert(this.translate.instant('page.nodes.import_failed'));
        } finally {
            this.importingCsv = false;
            await this.service.render();
        }
    }

    private openCsvImportConflictReview(fileData: string, data: any, conflicts?: any[]) {
        const rows = Array.isArray(conflicts)
            ? conflicts
            : (Array.isArray(data?.conflicts) ? data.conflicts : (data?.duplicates || []));
        this.pendingCsvImportData = fileData;
        this.csvImportPreviewTotal = Number(data?.total || rows.length || 0);
        this.duplicateImportRows = rows;
        this.duplicateImportActions = {};
        rows.forEach((row: any) => this.duplicateImportActions[row.row] = 'skip');
        this.showDuplicateImportModal = true;
    }

    public get csvImportConflictCount(): number {
        return this.duplicateImportRows.length;
    }

    public get csvImportSafeRowCount(): number {
        return Math.max(0, this.csvImportPreviewTotal - this.csvImportConflictCount);
    }

    public duplicateImportOptions(row: any): Array<{ value: string; labelKey: string; }> {
        if (row?.can_overwrite === false) {
            return this.duplicateImportActionOptions.filter((option: any) => option.value === 'skip');
        }
        return this.duplicateImportActionOptions;
    }

    private async executeCsvImport(fileData: string, duplicateActions: any): Promise<boolean> {
        const { code, data } = await wiz.call("import_csv", {
            file_data: fileData,
            duplicate_actions: JSON.stringify(duplicateActions || {}),
        });
        if (code === 200) {
            this.csvImportResult = data;
            const success = Number(data?.success || 0);
            const updated = Number(data?.updated || 0);
            const skipped = Number(data?.skipped || 0);
            const failed = Array.isArray(data?.failed) ? data.failed.length : 0;
            alert(this.translate.instant('page.nodes.import_complete', { success, updated, skipped, failed }));
            await this.load(1, false);
            return true;
        } else if (code === 409 && data?.requires_confirmation) {
            this.openCsvImportConflictReview(fileData, data);
            return false;
        } else {
            alert(data?.message || this.translate.instant('page.nodes.import_failed'));
            return false;
        }
    }

    public setDuplicateImportAction(row: any, action: string) {
        this.duplicateImportActions[row] = action;
    }

    public async confirmDuplicateImport() {
        if (!this.pendingCsvImportData || this.importingCsv) return;
        const fileData = this.pendingCsvImportData;
        const actions = { ...this.duplicateImportActions };
        this.showDuplicateImportModal = false;
        this.importingCsv = true;
        await this.service.render();
        let completed = false;
        try {
            completed = await this.executeCsvImport(fileData, actions);
        } catch (error) {
            console.error(error);
            alert(this.translate.instant('page.nodes.import_failed'));
        } finally {
            if (completed || !this.showDuplicateImportModal) {
                this.pendingCsvImportData = '';
                this.csvImportPreviewTotal = 0;
                this.duplicateImportRows = [];
                this.duplicateImportActions = {};
            }
            this.importingCsv = false;
            await this.service.render();
        }
    }

    public async cancelDuplicateImport() {
        this.showDuplicateImportModal = false;
        this.pendingCsvImportData = '';
        this.csvImportPreviewTotal = 0;
        this.duplicateImportRows = [];
        this.duplicateImportActions = {};
        await this.service.render();
    }

    public downloadCsvSample() {
        const guide = [
            '# KiERA Node CSV Import Guide',
            '# 필수: name. 지정 IP·MAC·BMC 주소는 해당 컬럼에 입력합니다.',
            '# 선택: bmc_credential_name, group_id, group_name, rack, unit, rack_size, boot_type은 비어 있어도 생성됩니다.',
            '# BMC Credential: 비우면 BMC Credentials에서 지정한 Default 프로필을 사용합니다. Default가 없으면 미할당입니다.',
            '# 그룹: group_id 또는 group_name으로 지정하며, 둘 다 비우면 기본 그룹에 등록됩니다.',
            '# rack/unit 빈칸은 미할당, rack_size 빈칸은 1U입니다. Ethernet 4개와 IB 2개의 name/ip/mac을 입력할 수 있습니다. 빈 인터페이스는 생성하지 않습니다.',
        ].join('\n');
        const examples: any[] = [
            { name: 'node-001', ip_address: '192.0.2.10', mac_address: '02:00:00:00:00:10',
              ethernet1_name: 'eth0', ethernet1_ip: '192.0.2.10', ethernet1_mac: '02:00:00:00:00:10',
              ib1_name: 'ib0', ib1_ip: '198.51.100.10' },
            { name: 'node-002', ip_address: '192.0.2.11' },
        ];
        const rows = [this.exportCsvFields.map(field => field.header),
            ...examples.map(row => this.exportCsvFields.map(field => row[field.key] ?? ''))];
        const csv = guide + '\n' + rows.map((row) => row.map((cell) => this.csvCell(cell)).join(',')).join('\n') + '\n';
        const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = 'kiera-node-sample.csv';
        anchor.click();
        URL.revokeObjectURL(url);
    }

    public async exportCsv() {
        if (this.exportingCsv) return;
        this.exportingCsv = true;
        await this.service.render();
        try {
            const rows = await this.loadExportRows();
            const csv = this.buildExportCsv(rows);
            const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8' });
            const url = URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = `kiera-nodes-${new Date().toISOString().slice(0, 10)}.csv`;
            anchor.click();
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error(error);
            alert(this.translate.instant('page.nodes.export_failed'));
        } finally {
            this.exportingCsv = false;
            await this.service.render();
        }
    }

    private async loadExportRows(): Promise<any[]> {
        const pageSize = 100;
        const rows: any[] = [];
        let page = 1;
        let expectedTotal = 0;

        while (true) {
            const { code, data } = await wiz.call("search", {
                ...this.search,
                page,
                dump: pageSize,
                export_fields: "1",
            });
            if (code !== 200) throw new Error(data?.message || this.translate.instant('page.nodes.export_failed'));

            const pageRows = Array.isArray(data?.rows) ? data.rows : [];
            rows.push(...pageRows);
            expectedTotal = Number(data?.total || rows.length || 0);

            const totalPages = Math.ceil(expectedTotal / pageSize) || 1;
            if (pageRows.length === 0 || page >= totalPages || rows.length >= expectedTotal) break;
            page += 1;
        }

        return rows;
    }

    private buildExportCsv(rows: any[]): string {
        const header = this.exportCsvFields.map((field) => this.csvCell(field.header)).join(',');
        const body = rows.map((row) => {
            return this.exportCsvFields.map((field) => {
                const value = field.key === 'bmc_credential_name'
                    ? this.bmcCredentialName(row)
                    : row?.[field.key];
                return this.csvCell(value);
            }).join(',');
        });
        return [header, ...body].join('\n') + '\n';
    }

    private csvCell(value: any): string {
        const text = String(value ?? '');
        if (/[",\n]/.test(text)) return `"${text.replace(/"/g, '""')}"`;
        return text;
    }

    public totalPages() {
        return Math.ceil(this.total / this.search.dump) || 1;
    }

    public pageList() {
        const tp = this.totalPages();
        const current = Math.min(tp, Math.max(1, Number(this.search.page || 1)));
        const start = Math.floor((current - 1) / this.pageWindowSize) * this.pageWindowSize + 1;
        const end = Math.min(tp, start + this.pageWindowSize - 1);
        const pages: number[] = [];
        for (let i = start; i <= end; i++) pages.push(i);
        return pages;
    }

    public async movePage(page: number) {
        const requested = Number(page || 1);
        const safePage = Number.isFinite(requested) ? requested : 1;
        const next = Math.min(this.totalPages(), Math.max(1, safePage));
        if (next === Number(this.search.page || 1)) return;
        await this.load(next);
    }

    public async changePageSize(size?: number) {
        const nextDump = Number(size || this.search.dump || 10);
        this.search.dump = this.pageSizeOptions.includes(nextDump) ? nextDump : 10;
        await this.load(1);
    }

    public viewNode(id: number) {
        this.service.href('/kiera/nodes/' + id);
    }

    // ===== Sorting =====
    public async sort(field: string) {
        if (this.sortField === field) {
            this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortField = field;
            this.sortDir = 'asc';
        }
        this.sortList();
        await this.service.render();
    }

    private sortList() {
        const field = this.sortField;
        const dir = this.sortDir === 'asc' ? 1 : -1;
        const numericFields = ['id', 'bmc_port'];
        this.list.sort((a: any, b: any) => {
            let va = a[field];
            let vb = b[field];
            if (va == null) va = '';
            if (vb == null) vb = '';
            if (numericFields.includes(field)) return (Number(va) - Number(vb)) * dir;
            return String(va).localeCompare(String(vb)) * dir;
        });
    }

    public getSortIcon(field: string): string {
        if (this.sortField !== field) return 'bx-sort-alt-2';
        return this.sortDir === 'asc' ? 'bx-sort-up' : 'bx-sort-down';
    }

    public normalizeStatus(value: any) {
        return String(value || '').trim().toLowerCase();
    }

    public statusLabel(value: any, fallback: string = 'none') {
        const normalized = this.normalizeStatus(value) || fallback;
        return normalized.replace(/[_-]+/g, ' ').toUpperCase();
    }

    public statusBadgeClass(value: any, kind: 'node' | 'deploy' = 'node') {
        const normalized = this.normalizeStatus(value);
        if (normalized === '' || normalized === 'none' || normalized === 'new') {
            return 'bg-zinc-100 text-zinc-600';
        }
        if (normalized.includes('failed') || normalized === 'error') {
            return 'bg-red-100 text-red-700';
        }
        if (normalized === 'deployed') {
            return 'bg-emerald-100 text-emerald-700';
        }
        if (normalized === 'ready') {
            return kind === 'deploy' ? 'bg-zinc-100 text-zinc-600' : 'bg-blue-100 text-blue-700';
        }
        if (normalized === 'commissioned') {
            return 'bg-sky-100 text-sky-700';
        }
        if (normalized === 'verify-pending' || normalized === 'pending') {
            return 'bg-violet-100 text-violet-700';
        }
        if (normalized.includes('relay')) {
            return 'bg-indigo-100 text-indigo-700';
        }
        if (normalized === 'commissioning' || normalized === 'deploying' || normalized === 'backing-up' || normalized === 'backup') {
            return 'bg-amber-100 text-amber-700';
        }
        return 'bg-zinc-100 text-zinc-600';
    }

    // =========================================================================
    // SOL (Serial Over LAN) — Popup Window
    // =========================================================================

    public openSOL(item: any) {
        const url = `/kiera/sol/${item.id}?name=${encodeURIComponent(item.name || 'Node #' + item.id)}`;
        const availWidth = window.screen?.availWidth || 1280;
        const availHeight = window.screen?.availHeight || 820;
        const width = Math.max(720, Math.min(1280, availWidth - 40));
        const height = Math.max(560, Math.min(820, availHeight - 60));
        const left = Math.max(0, Math.round((availWidth - width) / 2));
        const top = Math.max(0, Math.round((availHeight - height) / 2));
        const popup = window.open(
            url,
            `sol_${item.id}`,
            `width=${width},height=${height},left=${left},top=${top},menubar=no,toolbar=no,location=no,status=no,resizable=yes,scrollbars=no`
        );
        if (popup) popup.focus();
    }

    public isTerminalAvailable(item: any) {
        const status = this.normalizeStatus(item?.status);
        const deployStatus = this.normalizeStatus(item?.deploy_status || item?.deploy_status_text);
        return status === 'deployed' || deployStatus === 'deployed';
    }

    public openTerminal(item: any) {
        const url = `/kiera/terminal/${item.id}?name=${encodeURIComponent(item.name || 'Node #' + item.id)}`;
        window.open(url, `terminal_${item.id}`, 'width=980,height=680,menubar=no,toolbar=no,location=no,status=no');
    }
}

export default PageKieraNodesComponent;
